import { StateCreator } from 'zustand';

export interface BatchPollingSlice {
    triggerBatchPolling: boolean;
    setTriggerBatchPolling: (trigger: boolean) => void;
}

export const createBatchPollingSlice: StateCreator<BatchPollingSlice, [], [], BatchPollingSlice> = (set) => ({
    triggerBatchPolling: false,
    setTriggerBatchPolling: (trigger: boolean) => set({ triggerBatchPolling: trigger })
});
